import { format } from 'date-fns';

// To see possible formats: https://date-fns.org/v2.4.1/docs/format
export const formatDateToReadableString = (date: number | Date, pattern?: string) => {
    return format(date, pattern || 'eeee d MMMM');
}